import {ReactComponent as active_dashboard} from '../assets/icons/icons8-active.svg'
import {ReactComponent as iconSmallArrowRight} from '../assets/icons/iconSmallArrowRight.svg'
import {ReactComponent as iconArrowRightSmallGray} from '../assets/icons/iconArrowRightSmallGray.svg'
import {ReactComponent as IconGoogle} from '../assets/icons/IconGoogle.svg'
import {ReactComponent as IconApple} from '../assets/icons/IconApple.svg'
import {ReactComponent as IconEyeOpen} from '../assets/icons/IconEyeOpen.svg'
import {ReactComponent as IconEyeClosed} from '../assets/icons/IconEyeClosed.svg'
import {ReactComponent as iconResetPlane} from '../assets/icons/iconResetPlane.svg'
import {ReactComponent as iconCross} from '../assets/icons/iconCross.svg'
export {iconCross}
import {ReactComponent as iconArrowLeft} from '../assets/icons/iconArrowLeft.svg'
import {ReactComponent as iconPencil} from '../assets/icons/iconPencil.svg'
import {ReactComponent as IconPatient} from '../assets/icons/IconPatient.svg'
import {ReactComponent as iconArrowRightPrimary} from '../assets/icons/iconArrowRightPrimary.svg'
import {ReactComponent as IconCorrectGreen} from '../assets/icons/IconCorrectGreen.svg'
import {ReactComponent as IconCorrectPrimary} from '../assets/icons/IconCorrectPrimary.svg'
import {ReactComponent as iconLocationPrimary} from '../assets/icons/iconLocationPrimary.svg'
import {ReactComponent as iconPhonePrimary} from '../assets/icons/iconPhonePrimary.svg'
import {ReactComponent as iconCalender} from '../assets/icons/iconCalender.svg'
import {ReactComponent as iconNotification} from '../assets/icons/iconNotification.svg'
import {ReactComponent as iconArrowdown} from '../assets/icons/iconArrowdown.svg'
import {ReactComponent as iconSearch} from '../assets/icons/iconSearch.svg'
import {ReactComponent as iconDashboard} from '../assets/icons/iconDashboard.svg'
import {ReactComponent as iconDashboardGray} from '../assets/icons/iconDashboardGray.svg'
import {ReactComponent as iconPracticeLocationGray} from '../assets/icons/iconPracticeLocationGray.svg'
import {ReactComponent as iconPracticeLocationPrimary} from '../assets/icons/iconPracticeLocationPrimary.svg'
import {ReactComponent as iconPatientGray} from '../assets/icons/iconPatientGray.svg'
import {ReactComponent as iconPatientPrimary} from '../assets/icons/iconPatientPrimary.svg'
import {ReactComponent as iconNewPatientsGray} from '../assets/icons/iconNewPatientsGray.svg'
import {ReactComponent as iconNewPatientsPrimary} from '../assets/icons/iconNewPatientsPrimary.svg'
import {ReactComponent as iconChatGray} from '../assets/icons/iconChatGray.svg'
import {ReactComponent as iconChatPrimary} from '../assets/icons/iconChatPrimary.svg'
import {ReactComponent as iconPracticeLocationSecondary} from '../assets/icons/iconPracticeLocationSecondary.svg'
import {ReactComponent as iconPatientPlus} from '../assets/icons/iconPatientPlus.svg'
import {ReactComponent as iconCrossRed} from '../assets/icons/iconCrossRed.svg'
import {ReactComponent as iconInfo} from '../assets/icons/iconInfo.svg'
import {ReactComponent as IconDashboardPatient} from '../assets/icons/IconPatient.svg'
import {ReactComponent as IconActiveSecondary} from '../assets/icons/IconActiveSecondary.svg'
import {ReactComponent as IconPracticeLocationGreen} from '../assets/icons/IconPractice locationGreen.svg'
import {ReactComponent as iconSubscription} from '../assets/icons/iconSubscription.svg'
import {ReactComponent as iconPhoneGray} from '../assets/icons/iconPhoneGray.svg'
import {ReactComponent as iconVerified} from '../assets/icons/iconVerified.svg'
import {ReactComponent as iconDCINumberCard} from '../assets/icons/iconDCINumberCard.svg'
import {ReactComponent as iconHospital} from '../assets/icons/iconHospital.svg'
import {ReactComponent as iconEmail} from '../assets/icons/iconEmail.svg'
import {ReactComponent as iconBuilding} from '../assets/icons/iconBuilding.svg'
import {ReactComponent as iconBadge} from '../assets/icons/iconBadge.svg'
import {ReactComponent as iconPencilPrimary} from '../assets/icons/iconPencilPrimary.svg'
import {ReactComponent as iconCamera} from '../assets/icons/iconCamera.svg'
import {ReactComponent as iconNote} from '../assets/icons/iconNote.svg'
import {ReactComponent as iconGallery} from '../assets/icons/iconGallery.svg'
import {ReactComponent as iconPlusPrimary} from '../assets/icons/iconPlusPrimary.svg'
import {ReactComponent as iconCloud} from '../assets/icons/iconUpload.svg'
import {ReactComponent as iconTeeths} from '../assets/icons/iconTeeths.svg'
import {ReactComponent as iconInfoPrimary} from '../assets/icons/iconInfoPrimary.svg'
import {ReactComponent as iconCalenderPrimary} from '../assets/icons/iconCalenderPrimary.svg'
import {ReactComponent as iconDropDown} from '../assets/icons/iconDropDown.svg'
import {ReactComponent as iconFilter} from '../assets/icons/iconFilter.svg'
import {ReactComponent as iconDropUp} from '../assets/icons/iconDropUp.svg'
import {ReactComponent as iconPlusWhite} from '../assets/icons/iconPlusWhite.svg'
import {ReactComponent as iconPlusBlack} from '../assets/icons/iconPlusBlack.svg'
import {ReactComponent as iconUpdate} from '../assets/icons/iconUpdate.svg'
import {ReactComponent as iconDropDownBig} from '../assets/icons/iconDropDownBig.svg'
import {ReactComponent as iconPin} from '../assets/icons/iconPin.svg'
import {ReactComponent as iconSend} from '../assets/icons/iconSend.svg'
import {ReactComponent as iconChatWhite} from '../assets/icons/iconChatWhite.svg'
import {ReactComponent as iconFillMail} from '../assets/icons/iconFillMail.svg'
import {ReactComponent as iconInfoDot} from '../assets/icons/iconInfoDot.svg'

import {ReactComponent as iconTimerGray} from '../assets/icons/iconTimerGray.svg'
import {ReactComponent as iconTimerGreen} from '../assets/icons/iconTimerGreen.svg'
import {ReactComponent as iconTeethsPrimary} from '../assets/icons/iconTeethsPrimary.svg'
import {ReactComponent as iconCalenderSecondary} from '../assets/icons/iconCalenderSecondary.svg'
import {ReactComponent as iconTeethGray} from '../assets/icons/iconTeethGray.svg'
import {ReactComponent as iconAppointment} from '../assets/icons/iconAppointment.svg'
import {ReactComponent as iconTeethSwitch} from '../assets/icons/iconTeethSwitch.svg'
import {ReactComponent as iconTeethsGray} from '../assets/icons/iconTeethsGray.svg'
import {ReactComponent as iconPlusGray} from '../assets/icons/iconPlusGray.svg'
import {ReactComponent as iconLayers} from '../assets/icons/iconLayers.svg'
import {ReactComponent as iconTeethsGreen} from '../assets/icons/iconTeethsGreen.svg'
import {ReactComponent as iconTimerOrange} from '../assets/icons/iconTimerOrange.svg'
import {ReactComponent as iconTimerPrimary} from '../assets/icons/iconTimerPrimary.svg'
import {ReactComponent as iconTimerRed} from '../assets/icons/iconTimerRed.svg'
import {ReactComponent as iconInfoBigDot} from '../assets/icons/iconInfoBigDot.svg'
import {ReactComponent as iconSelect} from '../assets/icons/iconSelect.svg'
import {ReactComponent as iconDeleteMinus} from '../assets/icons/iconDeleteMinus.svg'
import {ReactComponent as iconDelete} from '../assets/icons/iconDelete.svg'
import {ReactComponent as iconNoteRed} from '../assets/icons/iconNoteRed.svg'
import {ReactComponent as iconBreadCrumbs} from '../assets/icons/iconBreadCrumbs.svg'
import {ReactComponent as iconForward} from '../assets/icons/iconForward.svg'
import {ReactComponent as iconBackward} from '../assets/icons/iconBackward.svg'
import {ReactComponent as ChatEmptyScreen} from '../assets/images/ChatEmptyScreen.svg'
import {ReactComponent as iconStatus} from '../assets/icons/iconStatus.svg'
import {ReactComponent as editWearDays} from '../assets/icons/editWearDays.svg'
import {ReactComponent as productionIconGray} from '../assets/icons/productionIcon.svg'
import {ReactComponent as productionIconPrimary} from '../assets/icons/primaryProductionIcon.svg'
import {ReactComponent as iconTimerReminderPrimary} from '../assets/icons/iconReminderTimerPrimary.svg'
import {ReactComponent as iconKebabMenu} from '../assets/icons/iconKebabMenu.svg'
import {ReactComponent as iconPencilDarkGray} from '../assets/icons/iconPencilDarkGray.svg'
import {ReactComponent as iconDeleteFill} from '../assets/icons/iconDeleteFill.svg'

import {ReactComponent as iconComputer} from '../assets/icons/iconComputer.svg'
import {ReactComponent as iconNurse} from '../assets/icons/nurse.svg'
import {ReactComponent as comingSoon} from '../assets/icons/comingSoon.svg'
import {ReactComponent as teethConnected} from '../assets/icons/teethConnected.svg'
import {ReactComponent as iconGraph} from '../assets/icons/iconGraph.svg'
import {ReactComponent as iconsProduction} from '../assets/icons/iconsProduction.svg'
import {ReactComponent as copyIcon} from '../assets/icons/copyIcon.svg'
import {ReactComponent as linkIcon} from '../assets/icons/linkIcon.svg'
import {ReactComponent as iconLinkGray} from '../assets/icons/iconLinkGray.svg'

import {ReactComponent as filterSvg} from '../assets/icons/Filter.svg'
import {ReactComponent as paginationNextIcon} from '../assets/icons/nextIcon.svg'
import {ReactComponent as rightArrowIcon} from '../assets/icons/rightArrowIcon.svg'
import {ReactComponent as iconRightArrayGray} from '../assets/icons/iconRightArrayGray.svg'
import {ReactComponent as CreateFolder} from '../assets/icons/CreateFolder.svg'
import {ReactComponent as uploadFiles} from '../assets/icons/UploadFiles.svg'
import {ReactComponent as renameIcon} from '../assets/icons/rename.svg'
import {ReactComponent as moveIcon} from '../assets/icons/move.svg'
import {ReactComponent as iconPlusBlue} from '../assets/icons/iconPlusBlue.svg'
import {ReactComponent as deleteIconFiles} from '../assets/icons/deleteIconFiles.svg'
import {ReactComponent as renameIconPrimary} from '../assets/icons/renameIconPrimary.svg'
import {ReactComponent as thumbIcon} from '../assets/icons/thumbIcon.svg'
import {ReactComponent as smileIcon} from '../assets/icons/smileIcon.svg'
import {ReactComponent as smileIconPrimary} from '../assets/icons/smileIconPrimary.svg'
import {ReactComponent as thumbIconPrimary} from '../assets/icons/thumbIconPrimary.svg'
import {ReactComponent as iconAttachTeethsGray} from '../assets/icons/iconAttachTeethsGray.svg'
import {ReactComponent as iconAttachTeethsPrimary} from '../assets/icons/iconAttachTeethsPrimary.svg'
import {ReactComponent as iconHamburgerMenu} from '../assets/icons/iconHamburgerMenu.svg'
import {ReactComponent as iconCrossWhite} from '../assets/icons/iconCrossWhite.svg'
import {ReactComponent as iconCheckedGreen} from '../assets/icons/iconCheckedGreen.svg'
import {ReactComponent as iconUpArrow} from '../assets/icons/UpArrowBordered.svg'
import {ReactComponent as openLink} from '../assets/icons/icons8-open-link.svg'
import {ReactComponent as iconTeethConnectedGray} from '../assets/icons/iconBraces.svg'
import {ReactComponent as iconExpandRight} from '../assets/icons/iconExpandRight.svg'
import {ReactComponent as bucketPrimary} from '../assets/icons/bucketPrimary.svg'

import {ReactComponent as iconBlueEmail} from '../assets/icons/iconBlueEmail.svg'
import {ReactComponent as identificationIcon} from '../assets/icons/IdentificationBadge.svg'
import {ReactComponent as iconBlueMobile} from '../assets/icons/iconBlueMobile.svg'
import {ReactComponent as iconPracticeLocation} from '../assets/icons/iconPracticeLocation.svg'

import {ReactComponent as iconLeadsPatient} from '../assets/icons/iconLeadsPatient.svg'
import {ReactComponent as iconInfoGray} from '../assets/icons/iconInfoGray.svg'
import {ReactComponent as iconCreateNote} from '../assets/icons/iconCreateNote.svg'
import {ReactComponent as iconUploadFile} from '../assets/icons/iconFile.svg'

import {ReactComponent as iconCarrier} from '../assets/icons/iconCarrier.svg'
import {ReactComponent as iconNotepad} from '../assets/icons/iconNotepad.svg'
import {ReactComponent as iconDownClock} from '../assets/icons/iconDownClock.svg'
import {ReactComponent as iconConnect} from '../assets/icons/iconConnect.svg'
import {ReactComponent as iconProductionBlue} from '../assets/icons/iconProductionBlue.svg'
import {ReactComponent as iconAddBlue} from '../assets/icons/iconAddBlue.svg'
import {ReactComponent as iconTickGreen} from '../assets/icons/iconTickGreen.svg'
import {ReactComponent as iconAddFilesBlue} from '../assets/icons/iconAddFIlesBlue.svg'
import {ReactComponent as iconPatientRed} from '../assets/icons/iconPatientRed.svg'
import {ReactComponent as iconPersonGray} from '../assets/icons/iconPersonGray.svg'
import {ReactComponent as iconPersonPrimary} from '../assets/icons/iconPersonPrimary.svg'
import {ReactComponent as iconProductionGray} from '../assets/icons/iconProductionGray.svg'
import {ReactComponent as iconProductionPrimary} from '../assets/icons/iconProductionPrimary.svg'
import {ReactComponent as iconSettingsGray} from '../assets/icons/iconSettingsGray.svg'
import {ReactComponent as iconSettingsPrimary} from '../assets/icons/iconSettingsPrimary.svg'
import {ReactComponent as iconBellGray} from '../assets/icons/iconBellGray.svg'
import {ReactComponent as iconBellPrimary} from '../assets/icons/iconBellPrimary.svg'
import {ReactComponent as iconMobilePrimary} from '../assets/icons/iconMobilePrimary.svg'
import {ReactComponent as iconsMobileGray} from '../assets/icons/iconsMobileGray.svg'
import {ReactComponent as iconTargetPrimary} from '../assets/icons/iconTargetPrimary.svg'
import {ReactComponent as switchArrowIcon} from '../assets/icons/switchArrowIcon.svg'

import {ReactComponent as iconTargetGray} from '../assets/icons/iconTargetGray.svg'
import {ReactComponent as iconRightPurpleArrow} from '../assets/icons/purpleRightArrow.svg'
import {ReactComponent as analyticPrimary} from '../assets/icons/analyticPrimary.svg'
import {ReactComponent as teethCap} from '../assets/icons/teethCap.svg'
import {ReactComponent as iconHash} from '../assets/icons/iconHash.svg'
import {ReactComponent as grayDropdownBig} from '../assets/icons/grayDropdownBig.svg'
import {ReactComponent as expandRightArrow} from '../assets/icons/arrow-down-sign-to-navigate.svg'
import {ReactComponent as iconsInfoRed} from '../assets/icons/iconsInfoRed.svg'
import {ReactComponent as rightArrowRed} from '../assets/icons/rightArrowRed.svg'
import {ReactComponent as iconReminder} from '../assets/icons/iconReminder.svg'
import {ReactComponent as iconAppointmentNote} from '../assets/icons/iconAppointmentNote.svg'
import {ReactComponent as patientTwoIcon} from '../assets/icons/patientTwoIcon.svg'
import {ReactComponent as iconUserCheck} from '../assets/icons/iconUserCheck.svg'
import {ReactComponent as iconHospitalNew} from '../assets/icons/iconHospitalNew.svg'
import {ReactComponent as iconFilterSearch} from '../assets/icons/iconFilterSearch.svg'

import {ReactComponent as iconTooth} from '../assets/icons/iconTooth.svg'
import {ReactComponent as iconType} from '../assets/icons/iconType.svg'
import {ReactComponent as iconSubtype} from '../assets/icons/iconSubtype.svg'
import {ReactComponent as iconBuildings} from '../assets/icons/iconBuildings.svg'
import {ReactComponent as iconBucketMarked} from '../assets/icons/iconBucketMarked.svg'
import {ReactComponent as iconSupport} from '../assets/icons/support.svg'
import {ReactComponent as iconCollapse} from '../assets/icons/iconCollapse.svg'
import {ReactComponent as iconExpand} from '../assets/icons/iconExpand.svg'

import {ReactComponent as Warehouse} from '../assets/icons/Warehouse.svg'
import {ReactComponent as Wrench} from '../assets/icons/Wrench.svg'
import {ReactComponent as HourglassMedium} from '../assets/icons/HourglassMedium.svg'
import {ReactComponent as UserCheck} from '../assets/icons/UserCheck.svg'

import {ReactComponent as ResizeIcon} from '../assets/icons/Resize.svg'
import {ReactComponent as CircleDashed} from '../assets/icons/CircleDashed.svg'
import {ReactComponent as Shapes} from '../assets/icons/Shapes.svg'
import {ReactComponent as ClipboardText} from '../assets/icons/ClipboardText.svg'

import {ReactComponent as Pulse} from '../assets/icons/Pulse.svg'
import {ReactComponent as PulseGold} from '../assets/icons/PulseGold.svg'
import {ReactComponent as ClipboardTextPrimary} from '../assets/icons/ClipboardTextPrimary.svg'
import {ReactComponent as ClipboardTextGold} from '../assets/icons/ClipboardTextGold.svg'
import {ReactComponent as commonUser} from '../assets/icons/User.svg'
import {ReactComponent as locationMapPin} from '../assets/icons/MapPin.svg'
import {ReactComponent as MapPinGray} from '../assets/icons/MapPinGray.svg'
import {ReactComponent as orderIcon} from '../assets/icons/Package.svg'
import {ReactComponent as threeUser} from '../assets/icons/UsersThree.svg'
import getBrandConfig from './getBrandConfig'
import {ReactComponent as iconUpArrowPurple} from '../assets/icons/icon_purple_up_arrow.svg'
import {ReactComponent as iconDownArrowPurple} from '../assets/icons/icon_purple_down_arrow.svg'
import {ReactComponent as uploadIcon} from '../assets/icons/CloudArrowUp.svg'
import {ReactComponent as redTraingle} from '../assets/icons/red_traingle.svg'
import {ReactComponent as uploadCouldIcon} from '../assets/icons/CloudArrowUp.svg'
import {ReactComponent as zipIcon} from '../assets/icons/FileZip.svg'

// Login & SignUp & forget password
export const SVG_GOOGLE = IconGoogle
export const SVG_APPLE = IconApple
export const SVG_EYE_CLOSE = IconEyeClosed
export const SVG_EYE_OPEN = IconEyeOpen
export const SVG_CROSS = iconCross
export const SVG_RESET_PLANE = iconResetPlane
export const SVG_COMPUTER = iconComputer
export const SVG_THUMB = thumbIcon
export const SVG_THUMB_PRIMARY = thumbIconPrimary
export const SVG_SMILE = smileIcon
export const SVG_SMILE_PRIMARY = smileIconPrimary
export const SVG_ATTACH_TEETHS_GRAY = iconAttachTeethsGray
export const SVG_ATTACH_TEETHS_PRIMARY = iconAttachTeethsPrimary
export const SVG_MOBILE_PRIMARY = iconMobilePrimary
export const SVG_MOBILE_GRAY = iconsMobileGray
export const SVG_TARGET_PRIMARY = iconTargetPrimary
export const SVG_TARGET_GRAY = iconTargetGray

// On board Screens
export const SVG_ARROW_LEFT_BLACK = iconArrowLeft
export const SVG_Gray_PENCIL = iconPencil
export const SVG_EYE_PATIENT_PRIMARY = IconPatient
export const SVG_ARROW_RIGHT_PRIMARY = iconArrowRightPrimary
export const SVG_CORRECT_GREEN = IconCorrectGreen
export const SVG_CORRECT_PRIMARY = IconCorrectPrimary
export const SVG_LOCATION_PRIMARY = iconLocationPrimary
export const SVG_PHONE_PRIMARY = iconPhonePrimary

// Header icon
export const SVG_CALENDER = iconCalender
export const SVG_NOTIFICATION = iconNotification
export const SVG_ARROW_DOWN = iconArrowdown
export const SVG_SEARCH = iconSearch

// SideBar
export const SVG_DASHBOARD_PRIMARY = iconDashboard
export const SVG_DASHBOARD_GRAY = iconDashboardGray
export const SVG_CLINIC_GRAY = iconPracticeLocationGray
export const SVG_CLINIC_PRIMARY = iconPracticeLocationPrimary
export const SVG_PATIENT_GRAY = iconPatientGray
export const SVG_PATIENT_PRIMARY = iconPatientPrimary
export const SVG_NEW_PATIENTS_GRAY = iconNewPatientsGray
export const SVG_NEW_PATIENTS_PRIMARY = iconNewPatientsPrimary
export const SVG_CHAT_GRAY = iconChatGray
export const SVG_CHAT_PRIMARY = iconChatPrimary
export const SVG_PRODUCTION_ICON_GRAY = productionIconGray
export const SVG_PRODUCTION_ICON_PRIMARY = productionIconPrimary
export const SVG_PERSON_GRAY = iconPersonGray
export const SVG_PERSON_PRIMARY = iconPersonPrimary
export const SVG_PRODUCTION_GRAY = iconProductionGray
export const SVG_PRODUCTION_PRIMARY = iconProductionPrimary
export const SVG_SETTINGS_GRAY = iconSettingsGray
export const SVG_SETTINGS_PRIMARY = iconSettingsPrimary
export const SVG_BELL_GRAY = iconBellGray
export const SVG_BELL_PRIMARY = iconBellPrimary
export const SVG_SUPPORT = iconSupport

// Dashboard
export const SVG_DASHBOARD_ACTIVE = active_dashboard
export const SVG_DASHBOARD_PATIENT = IconPatient
export const SVG_ARROW_RIGHT = iconSmallArrowRight
export const SVG_DASHBOARD_CLINIC = iconPracticeLocationSecondary
export const SVG_DASHBOARD_PATIENT_PLUS = iconPatientPlus
export const SVG_LOCATION_MAP_PIN = locationMapPin
export const SVG_LOCATION_MAP_PIN_GRAY = MapPinGray
export const SVG_CROSS_RED = iconCrossRed
export const SVG_CROSS_WHITE = iconCrossWhite
export const SVG_ARROW_RIGHT_GRAY = iconArrowRightSmallGray
export const SVG_INFO = iconInfo
export const SVG_NURSE = iconNurse
export const SVG_COMING_SOON = comingSoon
export const SVG_TEETH_CONNECTED_PRIMARY = teethConnected
export const SVG_GRAPH = iconGraph
export const SVG_PRODUCTION = iconsProduction
export const SVG_HAMBURGER = iconHamburgerMenu

// Dr Profile
export const SVG_PROFILE_PATIENT = IconDashboardPatient
export const SVG_PROFILE_ACTIVE = IconActiveSecondary
export const SVG_PROFILE_CLINIC = IconPracticeLocationGreen
export const SVG_PROFILE_SUBSCRIPTION = iconSubscription
export const SVG_PENCIL_PRIMARY = iconPencilPrimary
export const SVG_PROFILE_PHONE = iconPhoneGray
export const SVG_PROFILE_DCI_NUMBER_CARD = iconDCINumberCard
export const SVG_PROFILE_HOSPITAL = iconHospital
export const SVG_PROFILE_EMAIL = iconEmail
export const SVG_PROFILE_BUILDING = iconBuilding
export const SVG_PROFILE_BADGE = iconBadge
export const SVG_VERIFIED = iconVerified
export const SVG_CAMERA = iconCamera

// SetUp
export const SVG_NOTE = iconNote
export const SVG_BREAD_CRUMBS = iconBreadCrumbs

// Gallery
export const SVG_GALLERY = iconGallery
export const SVG_CLOUD = iconCloud
export const SVG_CLOUD_UP_ARROW = uploadCouldIcon
export const SVG_PLUS_PRIMARY = iconPlusPrimary
export const SVG_UPLOAD_CLOUD_ICON = uploadIcon

// Treatment
export const SVG_TEETHS = iconTeeths
export const SVG_CALENDER_PRIMARY = iconCalenderPrimary
export const SVG_INFO_PRIMARY = iconInfoPrimary
export const SVG_UPDATE = iconUpdate
export const SVG_WEAR_DAYS = editWearDays
export const SVG_TEETH_CONNECTED_GRAY = iconTeethConnectedGray
export const SVG_EXPAND_RIGHT = iconExpandRight
export const SVG_EXPAND_RIGHT_GREEN = expandRightArrow

// Listing
export const SVG_DROPDOWN = iconDropDown
export const SVG_FILTER = iconFilter
export const SVG_DROPUP = iconDropUp
export const SVG_PLUS_WHITE = iconPlusWhite
export const SVG_PLUS_BLACK = iconPlusBlack
export const SVG_CHAT_WHITE = iconChatWhite
export const SVG_COPY = copyIcon
export const SVG_LINK = linkIcon
export const SVG_LINK_GRAY = iconLinkGray
export const SVG_RIGHT_ARROW_GRAY = iconRightArrayGray

//patient profile
export const SVG_DROPDOWN_BIG = iconDropDownBig
export const SVG_PIN = iconPin
export const SVG_SEND = iconSend
export const SVG_FILL_MAIL = iconFillMail
export const SVG_INFO_DOT = iconInfoDot
export const SVG_NOTE_RED = iconNoteRed

export const SVG_TIMER_GREEN = iconTimerGreen
export const SVG_TEETH_PRIMARYT = iconTeethsPrimary
export const SVG_CALENDER_SECONDARY = iconCalenderSecondary
export const SVG_TIMER_GRAY = iconTimerGray
export const SVG_TIMER_RED = iconTimerRed
export const SVG_TEETH_GRAY = iconTeethGray
export const SVG_APPOINTMENT = iconAppointment
export const SVG_TEETHS_SWITCH = iconTeethSwitch
export const SVG_TEETHS_GRAY = iconTeethsGray
export const SVG_PLUS_GRAY = iconPlusGray

export const SVG_LAYERS = iconLayers
export const SVG_TEETHS_GREEN = iconTeethsGreen
export const SVG_TIMER_ORANGE = iconTimerOrange
export const SVG_TIMER_PRIMARY = iconTimerPrimary
export const SVG_FORWARD = iconForward
export const SVG_BACKWARD = iconBackward
export const SVG_STATUS = iconStatus

//Production
export const SVG_TIMER_REMINDER_PRIMARY = iconTimerReminderPrimary
export const SVG_KEBAB_MENU = iconKebabMenu
export const SVG_PENCIL_DARK_GRAY = iconPencilDarkGray
export const SVG_DELETE_FILL = iconDeleteFill

// Common
export const SVG_INFO_BIG_DOT = iconInfoBigDot
export const SVG_SELECT = iconSelect
export const SVG_DELETE_MINUS = iconDeleteMinus
export const SVG_DELETE = iconDelete
export const SVG_D_ICON = getBrandConfig().favIcon
export const UP_ARROW_BORDERED = iconUpArrow

export const SVG_CHAT_EMPTY_STATE = ChatEmptyScreen
export const SVG_PRODUCTION_FILTER = filterSvg
export const SVG_PAGINATION_NEXT = paginationNextIcon
export const SVG_RIGHT_ARROW_ICON = rightArrowIcon
export const SVG_OPEN_LINK = openLink

export const SVG_BLUE_EMAIL = iconBlueEmail
export const SVG_BLUE_IDENTIFICATION = identificationIcon
export const SVG_BLUE_MOBILE = iconBlueMobile
export const SVG_PRACTICE_LOCATION = iconPracticeLocation

export const SVG_LEADS_PATIENT = iconLeadsPatient
export const SVG_INFO_GRAY = iconInfoGray
export const SVG_CREATE_NOTE = iconCreateNote
export const SVG_UPLOAD_FILE = iconUploadFile

export const SVG_DOWN_CLOCK = iconDownClock
export const SVG_NOTEPAD = iconNotepad
export const SVG_CARRIER = iconCarrier
export const SVG_COLLAPSE = iconCollapse
export const SVG_EXPAND = iconExpand
export const SVG_UP_ARROW = iconUpArrowPurple
export const SVG_DOWN_ARROW = iconDownArrowPurple
//files
export const SVG_CREATE_FOLDER = CreateFolder
export const SVG_UPLOAD_FILES = uploadFiles
export const SVG_RENAME_ICON = renameIcon
export const SVG_RENAME_ICON_PRIMARY = renameIconPrimary
export const SVG_MOVE_ICON = moveIcon
export const SVG_PLUS_BLUE = iconPlusBlue
export const SVG_DELETE_ICON_FILES = deleteIconFiles
export const SVG_ZIP_FILE = zipIcon

// Leads Profile
export const SVG_BUCKET = bucketPrimary
export const SVG_ANALYTICS = analyticPrimary
export const SVG_TEETH_CAP_GRAY = teethCap
//Leads
export const SVG_CONNECT = iconConnect
export const SVG_PRODUCTION_BLUE = iconProductionBlue
export const SVG_ADD_BLUE = iconAddBlue
export const SVG_TICK_GREEN = iconTickGreen
export const SVG_ADD_FILES_BLUE = iconAddFilesBlue
export const SVG_PATIENT_RED = iconPatientRed
export const SVG_PURPLE_RIGHT_ARROW = iconRightPurpleArrow
export const SVG_USER_CHECK = iconUserCheck
export const SVG_HOSPITAL_NEW = iconHospitalNew
export const SVG_ORDER = orderIcon
export const SVG_THREE_USER = threeUser

//Manual Tracking
export const SVG_HASH = iconHash
export const SVG_SWITCH_ARROW = switchArrowIcon
export const SVG_INFO_RED = iconsInfoRed
export const SVG_RIGHT_ARROW_RED = rightArrowRed
export const SVG_DROPDOWN_GRAY_BIG = grayDropdownBig

//Appointment
export const SVG_REMINDER = iconReminder
export const SVG_APPOINTMENT_NOTE = iconAppointmentNote
export const SVG_PATIENT_TWO_GRAY = patientTwoIcon
export const SVG_FILTER_SEARCH = iconFilterSearch

//Braces
export const SVG_TOOTH = iconTooth
export const SVG_TYPE = iconType
export const SVG_SUBTYPE = iconSubtype
export const SVG_BUILDING = iconBuildings
export const SVG_CHECKED_GREEN = iconCheckedGreen
export const SVG_BUCKET_MARKED = iconBucketMarked

export const SVG_RESIZE = ResizeIcon
export const SVG_CIRCLE_DASHED = CircleDashed
export const SVG_SHAPES = Shapes
export const SVG_CLIPBOARD_TEXT = ClipboardText

// Production
export const SVG_SETTING_PRODUCTION = Wrench
export const SVG_USER_CHECK_SECONDARY = UserCheck
export const SVG_UNPROCESSED = HourglassMedium
export const SVG_PRODUCTION_SECONDARY = Warehouse

// getting started patient
export const SVG_USER_COMMON_PRIMARY = commonUser
export const SVG_PULSE_GOLD = PulseGold
export const SVG_PULSE_PRIMARY = Pulse
export const SVG_CLIPBOARD_GOLD = ClipboardTextGold
export const SVG_CLIPBOARD_PRIMARY = ClipboardTextPrimary
export const SVG_RED_TRAINGLE = redTraingle
